import config from "../../config";
import {
    AUTH_FAIL,
    AUTH_GETFROMTOKEN_SUCCESS,
    AUTH_LOGOUT,
    AUTH_START,
    AUTH_SUCCESS,
    SET_AUTH_REDIRECT_PATH,
    AUTH_ROLE_LOADED,
    AUTH_TEACHER_LOADED
} from "../actionTypes";
import {
    useQuery,
} from 'react-query';
import { endExpiredSession, isAuthErrorStatus } from '../../utils/authSession';


export const authStart = () => {
    return {
        type: AUTH_START
    }
}


export const authSuccess = (authData) => {
    return {
        type: AUTH_SUCCESS,
        // id: authData.id,
        // userId: authData.userId,
        error: null,
        ...authData

    }
}

export const authGetFromTokenSuccess = (authData) => {
  return {
    type: AUTH_GETFROMTOKEN_SUCCESS,
    error: null,
    payload: authData

  }
}



export const authFail = (error) => {
    console.log("AuthAction.authFail", error);
    return {
        type: AUTH_FAIL,
        error : error
    }
}


export const authLogout = () => {
    return {
        type: AUTH_LOGOUT,
        id: null
    };
}

export const checkAuthTimeout = (expirationTime) => {
    // return dispatch => {
    //     setTimeout(() => {
    //         console.log('TIMEOUT DISPATCHED!!')
    //         dispatch(logout());
    //
    //     }, expirationTime)
    // }
}

export const useGetProfile = () => {
    const context = useQuery('auth', () => localStorage.getItem('token') , {retry: false} );
    return { ...context, data: context.data };
};

const parseAuthenticatedResponse = async (response) => {
    if (isAuthErrorStatus(response.status)) {
        endExpiredSession();
        throw new Error('Sessao expirada');
    }

    return response.json();
}


export const getFromToken = () => {

    return async (dispatch,getState) => {

      console.log("getState", getState())

        const urlu = `${config.BASE_URL}/FermiUsers/getData`;
        fetch(urlu, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': getState().auth?.id || localStorage.getItem('token-id'),
                'Content-Type': 'application/json'
            }
        })
          .then(parseAuthenticatedResponse)
          .then((responseJSONu) => {
              if (responseJSONu.error) {
                localStorage.removeItem('token-id');
                localStorage.removeItem('userId');
                localStorage.removeItem('username');
                dispatch(authLogout());
              } else {
                  console.log(responseJSONu);
                  const userId = responseJSONu.id;
                  delete responseJSONu.id;
                  const dados = {
                    ...responseJSONu
                  };
                  console.log("auth action dados", dados);
                  delete dados.id;
                  dispatch(authGetFromTokenSuccess(dados));
                  const storedUserId = localStorage.getItem('userId');
                  dispatch(fetchUserRole(storedUserId || userId));
                  dispatch(fetchUserTeacher(storedUserId || userId));
              }
          })
          .catch(e => {
          })
    }
}


export const authRquery = async (username, password) => {
/// auth provinda da rquery

    // console.log('dispatched', username, password);

    let userdata = {
        username: username,
        password: password
    };
    //  console.log('body', JSON.stringify(userdata));
    const url = `${config.BASE_URL}/FermiUsers/Login`;
    return fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body:  JSON.stringify(userdata)
    })
        .then((response) => response.json())
        .then((responseJSON) => {
            console.log('auth url response', responseJSON);
            if (responseJSON && !responseJSON.id) {
                //// Pesquisa por login de aluno
                // busca codigo do aluno
                //dispatch(authFail(responseJSON));
            }
            else {
                // Busca dados usuario
                const urlu = `${config.BASE_URL}/FermiUsers/${responseJSON.userId}?filter={ "include": ["persons"] }`;
                //    console.log(urlu);
                return fetch(urlu, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': responseJSON.id,
                        'Content-Type': 'application/json'
                    }
                })
                    .then((responseu) => responseu.json())
                    .then((responseJSONu) => {
                        //      console.log(responseJSONu)
                        //delete responseJSONu.id;
                        const dados = {
                            token: responseJSON,
                            user: responseJSONu
                        };
                        console.log("auth dados", dados);
                        return dados;
                        // dispatch(authSuccess(dados));
                        // dispatch(checkAuthTimeout(responseJSON.ttl));
                    })
            }
        })
        .catch(error => {
            console.log('Error while running Login api: ', error);
            //  dispatch(authFail(error));
        });



}

export const auth = (username, password) => {
    return dispatch => {
        //console.log('dispatched', username, password);
        dispatch(authStart());
        let userdata = {
            username: username,
            password: password
        };
        console.log('body', JSON.stringify(userdata));
        const url = `${config.BASE_URL}/FermiUsers/Login`;
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body:  JSON.stringify(userdata)
        })
            .then((response) => response.json())
            .then((responseJSON) => {
                console.log('auth url response', responseJSON);
                if (responseJSON && !responseJSON.id) {
                    //// Pesquisa por login de aluno
                              // busca codigo do aluno
                    dispatch(authFail(responseJSON));
                }
                else {
                    // Busca dados usuario
                    const urlu = `${config.BASE_URL}/FermiUsers/${responseJSON.userId}?filter={ "include": ["persons"] }`;
                    console.log(urlu);
                    fetch(urlu, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': responseJSON.id,
                            'Content-Type': 'application/json'
                        }
                    })
                      .then((responseu) => responseu.json())
                      .then((responseJSONu) => {
                          console.log(responseJSONu)
                          delete responseJSONu.id;
                          const dados = {
                              ...responseJSON,
                              ...responseJSONu
                          };
                          console.log("auth action dados", dados);

                          dispatch(authSuccess(dados));
                          dispatch(fetchUserRole(responseJSON.userId));
                          dispatch(fetchUserTeacher(responseJSON.userId));
                          // dispatch(checkAuthTimeout(responseJSON.ttl));
                      })
                }
            })
            .catch(error => {
                console.log('Error while running Login api: ', error);
              //  dispatch(authFail(error));
            });


    }
}


export const fetchUserRole = (userId) => {
    return async (dispatch, getState) => {
        try {
            const token = getState().auth?.id || localStorage.getItem('token-id');
            const filter = JSON.stringify({
                where: { principalId: String(userId), principalType: "USER" },
                include: "role"
            });
            const url = `${config.BASE_URL}/RoleMappings?filter=${encodeURIComponent(filter)}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            });
            const data = await parseAuthenticatedResponse(response);
            const roleName = data?.[0]?.role?.name || null;
            console.log("fetchUserRole", userId, roleName, data);
            dispatch({ type: AUTH_ROLE_LOADED, roleName });
        } catch (e) {
            console.error("fetchUserRole ERROR", e);
            dispatch({ type: AUTH_ROLE_LOADED, roleName: null });
        }
    }
}

export const fetchUserTeacher = (userId) => {
    return async (dispatch, getState) => {
        try {
            const token = getState().auth?.id || localStorage.getItem('token-id');
            const filter = JSON.stringify({ where: { User_id: userId } });
            const url = `${config.BASE_URL}/Teachers?filter=${encodeURIComponent(filter)}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            });
            const data = await parseAuthenticatedResponse(response);
            const teacherId = data?.[0]?.id || null;
            console.log("fetchUserTeacher", userId, teacherId, data);
            dispatch({ type: AUTH_TEACHER_LOADED, teacherId });
        } catch (e) {
            console.error("fetchUserTeacher ERROR", e);
            dispatch({ type: AUTH_TEACHER_LOADED, teacherId: null });
        }
    }
}

export const setAuthRedirectPath = (path) => {
    return {
        type: SET_AUTH_REDIRECT_PATH,
        path: path
    };
};
